export default {
    whichEmbryosShouldBeKept                        :   "کدام جنین ها باید نگهداری شوند",
    whichEmbryoDoYouWantToTransfer                  :   "کدام جنین را می خواهید انتقال دهید",
    whatDoYouDoWithAnUnwantedFetus                  :   "با جنین غیردلخواه چه می کنید",
    description                                     :   "توضیحات"
}